import type { SponsorCategory } from "../types";

export function getAllSponsors(categories: SponsorCategory[]) {
  return categories.flatMap((category) => category.organisations);
}
